import { render, staticRenderFns } from "./OnlineWaMassCampaignsTable.vue?vue&type=template&id=8800118a&scoped=true&"
import script from "./OnlineWaMassCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./OnlineWaMassCampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaMassCampaignsTable.vue?vue&type=style&index=0&id=8800118a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8800118a",
  null
  
)

export default component.exports